<template>
  <v-fade-transition>
    <div class="RoomOverPrice">
      <div class="corner" :style="{backgroundColor:$color.primary}"></div>
      <div class="price" :style="{backgroundColor:$color.primary}">
        <div class="amount" >
          <span class="from">ОТ</span>
          <span class="value promo" v-if="room ==='familyLux'">{{promoPrice}}</span>
          <span class="value">{{price}}</span>
          <img class="ruble" :src="require(`@/assets/icons/ruble.png`)">
        </div>

        <span class="subtitle">ЗА ГОСТЯ</span>
      </div>


    </div>
  </v-fade-transition>

</template>




<script>
  export default {
  name: 'RoomOverPrice',
    props:['price','room'],
  data: () => ({
    promoPrice: 0,
  }),
  methods:{scrollUp(){
      let scrollHeight = document.getElementById('contentStart').offsetTop
      if(this.$screen.device==='mobile'){scrollHeight = scrollHeight-this.$ui.size.mobileNav}
      document.getElementById('showContent').scrollTo({top: scrollHeight, behavior: 'smooth'})}
    },
  mounted() {
    this.promoPrice = this.price * 1.2;
  },
}
</script>

<style scoped>
  .RoomOverPrice{z-index: 1; bottom: 50px; right: 0px; position: absolute; height: 40px; ; display: grid; grid-template-columns: auto 1fr;}
  .RoomOverPrice>.corner{ width: 14px; margin-right: -1px; clip-path: polygon(100% 0, 100% 100%, 0 50%);}
  .RoomOverPrice>.price{display: grid; justify-content: center; align-content: center; padding-bottom: 3px}
  .RoomOverPrice>.price>.subtitle{color: white; font-size: 9px; line-height: 0px; padding-top: 2px; text-align: center; margin-left: -8px}

  .RoomOverPrice>.price>.amount{color:white;display: grid; column-gap: 4px; align-items: center; justify-items: flex-end; grid-auto-flow: column; padding-right: 10px; }
  .RoomOverPrice>.price>.amount>.from{font-size: 11px}
  .RoomOverPrice>.price>.amount>.value{font-weight: bold}
  .RoomOverPrice>.price>.amount>.value.promo{text-decoration: line-through; opacity: 0.5; font-weight: normal;color: red}
  .RoomOverPrice>.price>.amount>.ruble{height: 12px; filter: invert()}
</style>
